import { render } from "./SmallArrow.vue?vue&type=template&id=1d054c9c"
const script = {}

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__